export default __webpack_public_path__ + "5d569075ec3360978e6977792e6a9b14.png";